import { render } from "./About.vue?vue&type=template&id=5fe8393d"
const script = {}
script.render = render

export default script